define(function(require) {
    // RESEAU_COLLEGIAL themeset definition config
    return  {
        ID : "Provincial",
        TYPE : "ThemeSetGroup",
        TITLE : "Graphiques provinciaux",
        THEMESETS_ELEMENTS : [
            {
                ID : "Provincial_1",
                TYPE : "ThemeSet",
                TITLE : "Taux annuel de sorties sans diplôme ni qualification (décrochage annuel) au secondaire à la FGJ, en fonction du sexe, par réseau d'enseignement, de 1999-2000 à 2019-2020",
                MASTER_THEMESETS_REMOVE: ["2022_2023", "2021_2022","2020_2021","2019_2020"],
            }, {
                ID : "Provincial_2",
                TYPE : "ThemeSet",
                TITLE : "Taux annuel de sorties sans diplôme ni qualification selon certaines caractéristiques, ensemble du Québec, 2008-2009 à 2019-2020",
                MASTER_THEMESETS_REMOVE: ["2022_2023", "2021_2022","2020_2021","2019_2020"],
            }
        ]
    };
});
